import * as React from 'react';
import { Button } from 'react-bootstrap';
import { getLocalization, globalWindow } from 'global/global';
import { useAppDispatch, useAppSelector } from 'index';
import { showDetail } from 'reducers/admin/ui';
import { PRICING_PER_TRANSACTION } from 'Interfaces/Admin';
import { showAdminImport } from '../ImportUsers';
import { showAccountSettings } from '../AccountSettingsModal';

const TUTORIALS_URL = 'https://www.youtube.com/playlist?list=PL2FfDWIZRVZTOkA2PmtAqh1YrA4Auy5b2';

/**
 *  The button row and usage counters that used to be static markup at the top
 *  of admin.tmpl.jsp, wired up by delegated jQuery handlers in admin.js.
 */
export default function AdminToolbar() {
  const dispatch = useAppDispatch();
  const account = useAppSelector((state) => state.admin.account);

  const {
    responsible_user: responsibleUser,
    transcriptionBudget, transcriptionUsage, transcriptionUsageUnits, transcriptionBudgetUnits,
    aiCredits, aiUsage, activeUsers, officeUsers, maxUsers, paymentSchedule, pricingPlan, db,
  } = account;

  const overTranscriptionBudget = transcriptionBudget > 0 && transcriptionUsage / transcriptionBudget >= 0.9;
  const overAiCredits = aiCredits > 0 && aiUsage / aiCredits >= 0.9;

  const showTransactionUsage = pricingPlan === PRICING_PER_TRANSACTION && maxUsers > 0;
  const overTransactions = showTransactionUsage && activeUsers / maxUsers >= 0.9;

  return (
    <div className="row admin-toolbar">
      <div className="col-5">
        <Button size="sm" onClick={() => dispatch(showDetail({ kind: 'group', id: null }))}>
          {getLocalization('addGroup')}
        </Button>
        <Button size="sm" onClick={() => dispatch(showDetail({ kind: 'user', id: null }))}>
          {getLocalization('addUser')}
        </Button>
        <Button size="sm" onClick={showAdminImport}>
          {getLocalization('importUsers')}
        </Button>
        <Button size="sm" onClick={() => dispatch(showDetail({ kind: 'campaign', id: null }))}>
          {getLocalization('addCampaign')}
        </Button>
        <Button size="sm" onClick={() => dispatch(showDetail({ kind: 'activity' }))}>
          {getLocalization('activity')}
        </Button>
        {responsibleUser && (
          <Button size="sm" onClick={showAccountSettings}>
            {getLocalization('accountSettings')}
          </Button>
        )}
        <Button variant="link" size="sm" href={TUTORIALS_URL} target="_blank" rel="noopener noreferrer">
          {getLocalization('tutorialVideos')}
        </Button>
      </div>

      <div className="col-7">
        <div className="float-right admin-usage">
          {showTransactionUsage && (
            <span className={overTransactions ? 'red-text' : 'green-text'}>
              {getLocalization('transactionUsage')} {activeUsers}&nbsp;/&nbsp;{maxUsers}
            </span>
          )}
          {transcriptionBudget > 0 && (
            <ul className="limitDiv">
              <li>
                {getLocalization('transcriptions')} :{' '}
                <span className={overTranscriptionBudget ? 'red-text' : ''}>
                  {transcriptionUsageUnits} {getLocalization('hours')}
                </span>{' '}
                / {transcriptionBudgetUnits} {getLocalization('hours')}
              </li>
            </ul>
          )}
          {aiCredits > 0 && (
            <ul className="limitDiv">
              <li>
                {getLocalization('aiCreditUsagePaid')} :{' '}
                <span className={overAiCredits ? 'red-text' : ''}>${aiUsage}</span> / ${aiCredits}
              </li>
            </ul>
          )}
          <ul className="limitDiv">
            <li>
              {getLocalization('activeUsers')} <span>{activeUsers}</span> (<span>{officeUsers}</span>)
            </li>
            {paymentSchedule?.toLowerCase() === 'prepaid' && (
              <li>{getLocalization('usersLimit')} (<span>{maxUsers}</span>)</li>
            )}
          </ul>

          <Button
            size="sm"
            onClick={() => dispatch(showDetail({ kind: 'accessLogs' }))}
          >
            {getLocalization('accessLogs')}
          </Button>
          {db === 'airliquide' && (
            <Button
              size="sm"
              onClick={() => { globalWindow.location = `//${globalWindow.location.host}/admin-rel3`; }}
            >
              {getLocalization('oldAdmin')}
            </Button>
          )}
        </div>
      </div>
    </div>
  );
}
